<template>
    <CCard v-if="order">
        <CCardHeader>
            <strong>Заказ #{{ order.id }} </strong> <small>{{ orderType }}</small>
        </CCardHeader>
        <CCardBody>
            <div class="flex items-center mb-2">
                <span class="w-1/3">Статус</span>
                <span class="w-2/3">
                    <CBadge :style="orderStatusStyle">&nbsp;{{ orderStatus }}&nbsp;</CBadge>
                    <CBadge v-if="isBusinessOrder" color="info" class="ml-2">B2B</CBadge>
                    <CBadge v-if="isShopOrder" class="ml-2 shop-order-badge" title="Стол заказов">СЗ</CBadge>
                    <CBadge v-if="order.payment_method === 'company_account'" color="primary" class="ml-1">Корпоративный счёт</CBadge>
                </span>
            </div>
            <div v-if="order.partner" class="flex items-center my-2">
                <span class="w-1/3">Партнер</span>
                <span class="w-2/3">
                    <CLink v-if="adminOnly" :to="{ path: '/partners/' + order.partner.id }">{{ order.partner.title }}</CLink>
                    <template v-else>{{ order.partner.title }}</template>
                </span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Бизнесы</span>
                <span class="w-2/3">
                    <ul>
                        <li v-for="link in orderCompanies" :key="link.title">
                            <template v-if="link.link"><CLink :to="link.link">{{ link.title }}</CLink></template>
                            <template v-else>{{ link.title }}</template>
                        </li>
                    </ul>
                </span>
            </div>
            <div v-if="order.external_id" class="flex items-center my-2">
                <span class="w-1/3"># в системе партнера</span>
                <span class="w-2/3">{{ order.external_id }}</span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Доставка</span>
                <span class="w-2/3">{{ getDeliveryTime() }}</span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Осталось</span>
                <span class="w-2/3">{{ getTimeRemaining() }}</span>
            </div>
            <div
                v-if="order.code === 'restaurant'" 
                class="flex items-center my-2">
                <span class="w-1/3">Осталось готовить</span>
                <span class="w-2/3">{{ getTimeRemainingForCooking() }}</span>
            </div>
            <div v-if="adminOnly && order.delivery_type !== DELIVERY_TYPE.WITHOUT" class="flex items-center my-2">
                <span class="w-1/3">Башня</span>
                <span class="w-2/3">{{ getTower() }}</span>
            </div>
            <div v-if="adminOnly" class="flex items-center my-2">
                <span class="w-1/3">Адрес</span>
                <span class="w-2/3">{{ getDeliveryAddress() }}</span>
            </div>
            <div v-if="adminOnly" class="flex items-center my-2">
                <span class="w-1/3">Клиент</span>
                <span class="w-2/3">
                    <CLink :to="`/customers/${order.customer.id}`">{{ order.customer.phone + " " + order.customer.firstname }} </CLink>
                    <CButton
                        variant="ghost"
                        color="primary"
                        class="mb-1 ml-10"
                        @click="customerEdit"
                        > <CIcon name="cil-pencil"/>
                    </CButton>
                </span>
            </div>
            <div v-if="adminOnly" class="flex items-center my-2">
                <span class="w-1/3">Комментарий о клиенте</span>
                <span class="w-2/3">{{ order.customer.description }}</span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Комментарий администратора</span>
                <span class="w-2/3 red">{{ order.comment ? order.comment : "" }}</span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Комментарий пользователя</span>
                <span class="w-2/3 red">{{ order.customer_comment ? order.customer_comment : "" }}</span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Дата создания</span>
                <span class="w-2/3">{{ formatDate(order.created_at) }}</span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Telegram</span>
                <span class="w-2/3">
                    <span :class="getBotSendClass(order.tg_sended)">{{ getBotSendIcon(order.tg_sended) }}</span>
                    {{ getBotSendText(order.tg_sended, 'Telegram') }}
                </span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">MAX</span>
                <span class="w-2/3">
                    <span :class="getBotSendClass(order.max_sended)">{{ getBotSendIcon(order.max_sended) }}</span>
                    {{ getBotSendText(order.max_sended, 'MAX') }}
                </span>
            </div>
            <div v-if="!adminOnly" class="flex items-center my-2">
                <span class="w-1/3">Время приготовления (осталось)</span>
                <span class="w-2/3">{{ awaitingTime() }}</span>
            </div>
            <div v-if="adminOnly && order.averageTime" class="flex items-center my-2">
                <span class="w-1/3">Среднее время приготовления</span>
                <span class="w-2/3">{{ order.averageTime }}</span>
            </div>
            <div v-if="!adminOnly" class="flex items-center my-2">
                <span class="w-1/3">Сумма заказа</span>
                <span class="w-2/3">{{ order.price }} р.</span>
            </div>
            <!-- <div class="flex items-center my-2">
                <span class="w-1/3">Промокод</span>
                <span class="w-2/3">
                    <CLink :to="{ path: '/promocodes/' + order.promocode_id }">{{ getPromocode() }}</CLink>
                </span>
            </div>
            <div class="flex items-center my-2">
                <span class="w-1/3">Акция</span>
                <span class="w-2/3">
                    <CLink :to="{ path: getPromotionLink() }">{{ getPromotion() }}</CLink>
                </span>
            </div> -->
            <template v-if="order.promocode && !adminOnly">
                <div class="flex items-center my-2">
                    <span class="w-1/3">Скидка по промокоду</span>
                    <span class="w-2/3">
                        {{ getPromocodeDetails() }} 
                        <span v-if="order.promocode_details && order.promocode_details.discount_percent">({{ getPromotionDiscountSum() }})</span>
                    </span>
                </div>
                <div class="flex items-center my-2">
                    <span class="w-1/3">За счет Партнера</span>
                    <span class="w-2/3">
                        {{ order.promocode && (order.promocode.discount_sum || order.promocode.discount_percent)
                            ? order.promocode.discount_sum ? `${+order.promocode.entity_discount_sum}р.` : ''
                            : order.promocode.discount_percent ? `${+order.promocode.entity_discount_percent}%` : '' }}
                    </span>
                </div>
                <div class="flex items-center my-2">
                    <span class="w-1/3">За счет МИРСИТИ</span>
                    <span class="w-2/3">
                        {{ order.promocode && (order.promocode.discount_sum || order.promocode.discount_percent)
                            ? order.promocode.discount_sum ? `${+order.promocode.discount_sum - +order.promocode.entity_discount_sum}р.` : ''
                            : order.promocode.discount_percent ? `${+order.promocode.discount_percent - +order.promocode.entity_discount_percent}%` : '' }}
                    </span>
                </div>
            </template>
            <template v-if="order.promotion && !adminOnly">
                <div class="flex items-center my-2">
                    <span class="w-1/3">Скидка по акции</span>
                    <span class="w-2/3">{{ getPromotionDetails() }} ({{ getPromotionDiscountSum() }})</span>
                </div>
                <div class="flex items-center my-2">
                    <span class="w-1/3">За счет Партнера</span>
                    <span class="w-2/3">{{ +order.promotion.entity_discount_percent }}%</span>
                </div>
                <div class="flex items-center my-2">
                    <span class="w-1/3">За счет МИРСИТИ</span>
                    <span class="w-2/3">{{ +order.promotion.discount - +order.promotion.entity_discount_percent }}%</span>
                </div>
            </template>
            <div v-if="adminOnly" class="flex items-center my-2">
                <span class="w-1/3">Платформа</span>
                <span class="w-2/3">{{ orderPlatform }}</span>
            </div>
        </CCardBody>
        <CCardFooter v-if="adminOnly">
            <CButton color="primary" @click="modal.visible = true">Редактировать</CButton>
            <CButton
                class="ml-3"
                color="info"
                @click="createCopy">Создать копию</CButton>
            <CButton
                class="ml-3"
                color="success"
                @click="updateOrderInfo">Обновить данные по заказу</CButton>
            <CButton
                v-if="isIikoOrder"
                class="ml-3"
                color="warning"
                :disabled="iikoStatusModal.loading"
                @click="fetchIikoStatus">
                {{ iikoStatusModal.loading ? 'Загрузка...' : 'Статус в iiko' }}
            </CButton>
        </CCardFooter>

        <CModal
            :show.sync="iikoStatusModal.visible"
            title="Статус заказа в iiko"
            size="lg">
            <div v-if="iikoStatusModal.error" class="text-danger">
                {{ iikoStatusModal.error }}
            </div>
            <div v-else-if="iikoStatusModal.data">
                <pre class="iiko-status-pre">{{ JSON.stringify(iikoStatusModal.data, null, 2) }}</pre>
            </div>
            <template #footer>
                <CButton color="secondary" @click="iikoStatusModal.visible = false">Закрыть</CButton>
            </template>
        </CModal>

        <OrderDetailsEdit
            :modal="modal"
            :order="order"
            @update="updateOrder"
            @update-promocode="onUpdateOrderPromocode"
            @cancel="modal.visible = false" />
        <CustomerEdit
            :modal="customerEditModal"
            @update="customerUpdate"
            @cancel="customerEditCancel" />
    </CCard>
</template>

<script>
    const {
        orderStatusTitle,
        orderStatusStyle,
        orderTypeTitle,
        orderPlatformFormat,
    } = require('../../utils/order-views');
    const { formatDate, formatDateShort, formatTimeShort } = require('../../utils/views');
    const {
        ORDER_TYPE,
        ORDER_STATUS,
        DELIVERY_TYPE,
    } = require('../../utils/order');
    import OrderDetailsEdit from './OrderDetailsEdit';
    import CustomerEdit from './CustomerEdit';
    import moment from 'moment';
    import countdown from 'countdown';
    countdown.setLabels(
        'мс|с|м|ч|д|н|мес|г|дек|век|мил',
        'мс|с|м|ч|д|н|мес|г|дек|век|мил',
        ' ',
        ' '
    );

    export default {
        name: 'OrderDetails',

        components: {
            OrderDetailsEdit,
            CustomerEdit,
        },

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            lastStatusUpdate: {
                type: String,
                default: () => (''),
            }
        },

        data() {
            return {
                isAuthorized: false,
                DELIVERY_TYPE,
                modal: {
                    visible: false,
                },
                customerEditModal: {
                    item: {},
                    visible: false,
                    emptyCustomer: {
                        customer: {},
                    },
                },
                adminOnly: false,
                newOrder: {},
                iikoStatusModal: {
                    visible: false,
                    loading: false,
                    data: null,
                    error: null,
                },
            };
        },

        computed: {
            orderType: function () {
                return orderTypeTitle(this.order.type);
            },
            orderStatus() {
                if (this?.order?.ed?.items?.length) {
                    return orderStatusTitle(
                        this.order.status,
                        this.order.type,
                        this.order.payment_type,
                        this?.order?.ed?.items[0]?.entity?.statuses,
                        this.order.delivery_type,
                        this.order.delivered_door,
                    );
                }
                return orderStatusTitle(
                    this.order.status,
                    this.order.type,
                    this.order.payment_type,
                    null,
                    this.order.delivery_type,
                    this.order.delivered_door,
                );
            },
            orderStatusStyle() {
                return orderStatusStyle(
                    this.order.status,
                    this.order.type,
                    this.order.payment_type
                );
            },
            orderCompanies() {
                const result = {};
                if (this.order.type === ORDER_TYPE.RESTAURANT_DELIVERY) {
                    if (this.order && this.order.rd && this.order.rd.items) {
                        for (const orderItem of this.order.rd.items) {
                            if (orderItem.restaurant && orderItem.restaurant.id) {
                                result[orderItem.restaurant.id] = {
                                    link: '/restaurants/' + orderItem.restaurant.id,
                                    title: orderItem.restaurant.title,
                                };
                            }
                        }
                    }
                }
                if (this.order.type === ORDER_TYPE.ENTITY_DELIVERY) {
                    if (this.order && this.order.ed && this.order.ed.items) {
                        for (const orderItem of this.order.ed.items) {
                            if (orderItem.entity && orderItem.entity.id) {
                                result[orderItem.entity.id] = {
                                    link: `/entities/${orderItem.entity.entityType.code}/${orderItem.entity.id}`,
                                    title: orderItem.entity.title,
                                };
                            }
                        }
                    }
                }
                if (this.order.type === ORDER_TYPE.FLOWERS_DELIVERY) {
                    if (this.order && this.order.fd && this.order.fd.items) {
                        for (const orderItem of this.order.fd.items) {
                            if (orderItem.florist && orderItem.florist.id) {
                                result[orderItem.florist.id] = {
                                    link: null,
                                    title: orderItem.florist.title,
                                };
                            }
                        }
                    }
                }
                if (this.order.type === ORDER_TYPE.GROCER_DELIVERY) {
                    if (this.order && this.order.gd && this.order.gd.items) {
                        for (const orderItem of this.order.gd.items) {
                            if (orderItem.grocer && orderItem.grocer.id) {
                                result[orderItem.grocer.id] = {
                                    link: '/grocers/' + orderItem.grocer.id,
                                    title: orderItem.grocer.title,
                                };
                            }
                        }
                    }
                }
                if (this.order.type === ORDER_TYPE.LAUNDRY_DELIVERY) {
                    if (this.order && this.order.ld && this.order.ld.items) {
                        for (const orderItem of this.order.ld.items) {
                            if (orderItem.laundry && orderItem.laundry.id) {
                                result[orderItem.laundry.id] = {
                                    link: null,
                                    title: orderItem.laundry.title,
                                };
                            }
                        }
                    }
                }
                if (this.order.type === ORDER_TYPE.PHARMACY_DELIVERY) {
                    if (this.order && this.order.pd && this.order.pd.items) {
                        for (const orderItem of this.order.pd.items) {
                            if (orderItem.pharmacy && orderItem.pharmacy.id) {
                                result[orderItem.pharmacy.id] = {
                                    link: '/pharmacies/' + orderItem.pharmacy.id,
                                    title: orderItem.pharmacy.title,
                                };
                            }
                        }
                    }
                }
                if (this.order.type === ORDER_TYPE.ASSISTANT_HELP) {
                    if (this.order && this.order.ah && this.order.ah.items) {
                        for (const orderItem of this.order.ah.items) {
                            if (orderItem.assistant && orderItem.assistant.id) {
                                result[orderItem.assistant.id] = {
                                    link: '/assistants/' + orderItem.assistant.id,
                                    title: orderItem.assistant.title,
                                };
                            }
                        }
                    }
                }
                return result;
            },
            orderPlatform() {
                if (this.order.device) {
                    return orderPlatformFormat(this.order.device);
                }
                return '';
            },
            isIikoOrder() {
                return !!(
                    this.order.external_id &&
                    this.order.type === ORDER_TYPE.RESTAURANT_DELIVERY
                );
            },
            isBusinessOrder() {
                return this.order && this.order.payment_method === 'company_account';
            },
            isShopOrder() {
                return this.order && this.order.code === 'shop';
            },
        },

        watch: {
            order: {
                deep: true,
                async handler() {
                    this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
                    if (this?.order?.ed?.items?.length) {
                        const entityId = this?.order?.ed?.items[0]?.entity_id;
                        const entitySettings = await this.axios.get(`/entities/settings/${entityId}`);
                        if (entitySettings?.data?.admin_access) {
                            this.adminOnly = true;
                        }
                    }
                }
            }
        },

        async mounted() {

        },

        methods: {
            onUpdateOrderPromocode(value) {
                if (value) {
                    this.newOrder = value;
                }
            },
            customerEdit(id) {
                this.customerEditModal.visible = true;
            },
            customerUpdate() {
                if (this.customerEditModal && this.customerEditModal.item.customer) {
                    this.order.baseInfoOnly = true;
                    this.order.customer = this.customerEditModal.item.customer;
                    this.order.customer_id = this.customerEditModal.item.customer.id;
                }
                this.$emit('update');
            },
            customerEditCancel() {
                this.customerEditModal.visible = false;
            },
            formatDate(date) {
                return (
                    formatDateShort(date) +
                    ' (' +
                    countdown(
                        new Date(date),
                        new Date(),
                        countdown.DAYS | countdown.HOURS | countdown.MINUTES
                    ).toString() +
                    ')'
                );
            },
            getDeliveryTime() {
                if (this.order.delivery_time) {
                    const prefix = this.order.delivery_now ? 'до ' : 'к ';
                    return (
                        prefix +
                        formatTimeShort(moment(this.order.delivery_time).toDate())
                    );
                }
                return '';
            },
            getTimeRemaining() {
                var dt = this.order.delivery_time;
                if (dt) {
                    dt = new moment(dt);
                    let theDate = new Date();
                    if (
                        this.order.status === ORDER_STATUS.DONE ||
                        this.order.status === ORDER_STATUS.CANCELED
                    ) {
                        theDate = moment(this.lastStatusUpdate).toDate();
                    }
                    return (
                        (moment(this.lastStatusUpdate).diff(dt) > 0 ? '- ' : '') +
                        countdown(
                            theDate,
                            new Date(dt.toDate()),
                            countdown.DAYS | countdown.HOURS | countdown.MINUTES
                        )
                    );
                }
                return '';
            },
            getTimeRemainingForCooking() {
                var dt = this.order.time_cooking;
                if (dt) {
                    dt = new moment(dt);
                    let theDate = new Date();
                    if (this.order.status === ORDER_STATUS.AWAITING) {
                        theDate = moment(this.lastStatusUpdate).toDate();
                    } else {
                        return '';
                    }
                    return (
                        (moment(this.lastStatusUpdate).diff(dt) > 0 ? '- ' : '') +
                        countdown(
                            theDate,
                            new Date(dt.toDate()),
                            countdown.DAYS | countdown.HOURS | countdown.MINUTES
                        )
                    );
                }
                return '';
            },
            awaitingTime() {
                var dt = this.order.delivery_time;
                if (dt) {
                    dt = new moment(dt).subtract(15, 'minutes');
                    let theDate = new Date();
                    if (
                        this.order.status === ORDER_STATUS.DONE ||
                        this.order.status === ORDER_STATUS.CANCELED
                    ) {
                        theDate = moment(this.lastStatusUpdate).toDate();
                    }
                    return (
                        (moment(this.lastStatusUpdate).diff(dt) > 0 ? '- ' : '') +
                        countdown(
                            theDate,
                            new Date(dt.toDate()),
                            countdown.DAYS | countdown.HOURS | countdown.MINUTES
                        )
                    );
                }
                return '';
            },
            getDeliveryAddress() {
                let address = '';
                if (!this.order.towerObj && this.order.address) {
                    address =
                        this.order.address.street +
                        ' ' +
                        this.order.address.building +
                        ', ';
                }
                if (this.order.delivery_type === DELIVERY_TYPE.MEETING_POINT) {
                    address = 'точка встречи';
                } else if (this.order.delivery_type === DELIVERY_TYPE.WITHOUT) {
                    address = 'без доставки';
                } else if (this.order.address_details) {
                    address +=
                        'вх. ' +
                        this.order.address_details.entrance +
                        ', эт. ' +
                        this.order.address_details.floor +
                        ', оф. ' +
                        this.order.address_details.appartment;
                }
                return address;
            },
            getPromocode() {
                if (this.order.promocode) {
                    return this.order.promocode.code;
                }
            },
            getPromotion() {
                if (this.order.promotion) {
                    return this.order.promotion.title;
                }
            },
            getPromocodeDetails() {
                if (
                    this.order.promocode_details &&
                    this.order.promocode_details.discount_percent
                ) {
                    return this.order.promocode_details.discount_percent + '%';
                }
                if (
                    this.order.promocode_details &&
                    this.order.promocode_details.discount_sum
                ) {
                    return this.order.promocode_details.discount_sum + 'р.';
                }
            },
            getPromotionDetails() {
                if (
                    this.order.promotion_details &&
                    this.order.promotion_details.discount_percent
                ) {
                    return this.order.promotion_details.discount_percent + '%';
                }
            },
            getPromotionDiscountSum() {
                const oldPrice = this.getOldPrice();
                const discountSum = this.order.promocode ? +this.order.promocode?.discount_sum : 0;
                // Minus promocode discount sum, cus we need to count it after discount %
                const refoundSum = this._getRefundFor(this.order, 'Партнера') + this._getRefundFor(this.order, 'МИРСИТИ');
                const allDiscountSum = (+this.order?.price && +oldPrice) ? ((+this.order?.price - +oldPrice) * -1) - discountSum - refoundSum : 0;
                return this.formatPrice(allDiscountSum);
            },
            _getRefundFor (order, name) {
                const orderItems = this.getOrderItemsByType(order)?.items;

                if (!orderItems) {
                    return 0;
                }

                const sum = orderItems.reduce((result, item) => {
                    if (item.refund_for === name) {
                        result += +item.refund_sum || 0;
                        return result;
                    }
                    return result;
                }, 0);
                return sum;
            },
            getOldPrice() {
                if (!this.order?.promocode && !this.order?.promotion) {
                    return this.order.price;
                }

                if (+this.order?.old_price > +this.order?.price) {
                    return this.order.old_price;
                }

                const promotion = this.order?.promotion;
                const promocode = this.order?.promocode;

                const items = this.getOrderItemsByType(this.order)?.items || [];
                let itemsPrice = items.reduce((total, item) => {
                    if (!item.enabled) {
                        return total;
                    }

                    let price = (+item?.old_price && +item?.old_price > +item?.price) ? +item?.old_price : +item?.price;
                    total += price * item?.quantity ? price * item?.quantity : price;

                    return total;
                }, 0);

                let orderOldPrice = 0;

                if (promotion && promocode) {
                    const discountFromPromotion = this._getPriceFromDiscount(this.order.price, promotion?.discount);
                    const discountFromPromocode = this._getPriceFromDiscount(this.order.price, promocode?.discount_percent);
                    const discountSumFromPromocode = +this.order.price - +promocode?.discount_percent;
                    let totalPrice = +this.order.price;

                    if (discountFromPromotion) {
                        totalPrice = discountFromPromotion;
                    }

                    if (discountSumFromPromocode && !discountFromPromocode) {
                        totalPrice += discountSumFromPromocode;
                    }

                    if (!discountSumFromPromocode && discountFromPromocode) {
                        totalPrice = discountFromPromocode;
                    }

                    orderOldPrice = totalPrice;
                }

                if (promotion && +promotion.discount) {
                    orderOldPrice = this._getPriceFromDiscount(this.order.price, promotion.discount);
                }

                if (promocode) {
                    if (+promocode.discount_sum) {
                        orderOldPrice = +this.order.price - promocode.discount_percent;
                    }
                    if (+promocode.discount_percent) {
                        orderOldPrice = this._getPriceFromDiscount(this.order.price, promocode.discount_percent);
                    }
                }

                if (!promotion && !promocode) {
                    if (this.order?.promocode_details?.discount_percent) {
                        orderOldPrice = this._getPriceFromDiscount(this.order.price, this.order?.promocode_details?.discount_percent);
                    }
                }
                orderOldPrice = +this.order.old_price || +this.order.price;

                return itemsPrice > 0 ? itemsPrice : orderOldPrice;
            },
            _getPriceFromDiscount (price, percent) {
                if (!price || !percent) {
                    return 0;
                }
                return (+price / (100 - +percent)) * 100;
            },
            getOrderItemsByType(order) {
                switch (order.type) {
                case ORDER_TYPE.FLOWERS_DELIVERY: return order.fd;
                case ORDER_TYPE.RESTAURANT_DELIVERY: return order.rd;
                case ORDER_TYPE.GROCER_DELIVERY: return order.gd;
                case ORDER_TYPE.LAUNDRY_DELIVERY: return order.ld;
                case ORDER_TYPE.PHARMACY_DELIVERY: return order.pd;
                case ORDER_TYPE.ASSISTANT_HELP: return order.ah;
                case ORDER_TYPE.ENTITY_DELIVERY: return order.ed;
                }
            },
            formatPrice(price) {
                return +(Math.round(price * 100) / 100).toFixed(2) + ' p.';
            },
            getPromotionLink() {
                let link = '';

                switch (this.order.type) {
                case ORDER_TYPE.RESTAURANT_DELIVERY:
                    link = `/restaurants/${this.order.rd.items[0].restaurant_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.GROCER_DELIVERY:
                    link = `/grocers/${this.order.gd.items[0].grocer_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.PHARMACY_DELIVERY:
                    link = `/pharmacies/${this.order.pd.items[0].pharmacy_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.ASSISTANT_HELP:
                    link = `/assistants/${this.order.ah.items[0].assistant_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.ENTITY_DELIVERY:
                    link = `/entities/${this.order.ed.items[0].entity.entityType.code}/${this.order.ed.items[0].entity_id}/promotions/${this.order.promotion_id}`;
                    break;
                }

                return link;
            },
            getTower() {
                return this.order.towerObj ? this.order.towerObj.name : '';
            },
            getBotSendIcon(value) {
                return value ? '✓' : '✗';
            },
            getBotSendClass(value) {
                return value ? 'bot-status-success' : 'bot-status-failed';
            },
            getBotSendText(value, channelName) {
                return value ? `Отправлено в ${channelName}` : `Не отправлено в ${channelName}`;
            },
            updateOrder() {
                if (this.newOrder.id) {
                    this.order = Object.assign({}, this.newOrder);
                } 
                this.order.baseInfoOnly = true;

                const price = this.order.price;
                const oldPrice = this.order.old_price;

                if (this?.order?.status !== 5 && !!this?.order?.delivered_door) {
                    this.order.delivered_door = false;
                }

                this.order.price = +(`${this.order.price}`.replace(/,/g, '.'));
                this.order.old_price = +(`${this.order.old_price}`.replace(/,/g, '.'));

                if ((!this.order.price && this.order.price !== 0) || (!this.order.old_price && this.order.old_price !== 0)) {
                    this.order.price = price;
                    this.order.old_price = oldPrice;
                    this.$root.$emit('showError', 'Неверно введена стоимость или старая стоимость.');
                    return;
                }
                if (this.newOrder.id) {
                    this.$emit('update', this.order);
                } else {
                    this.$emit('update');
                }
            },
            createCopy() {
                this.$emit('copy');
            },
            updateOrderInfo() {
                this.$emit('info');
            },
            async fetchIikoStatus() {
                this.iikoStatusModal.loading = true;
                this.iikoStatusModal.data = null;
                this.iikoStatusModal.error = null;
                try {
                    const response = await this.axios.get(`/orders/${this.order.id}/iiko-status`);
                    this.iikoStatusModal.data = response.data;
                    this.iikoStatusModal.visible = true;
                } catch (e) {
                    const errorMsg = e?.response?.data?.error || e?.message || 'Неизвестная ошибка';
                    this.iikoStatusModal.error = errorMsg;
                    this.iikoStatusModal.visible = true;
                } finally {
                    this.iikoStatusModal.loading = false;
                }
            },
        },
    };
</script>
<style scoped>
.shop-order-badge {
    background-color: #6f42c1;
    color: #fff;
}
.red {
    color: red;
}
.bot-status-success {
    color: #2eb85c;
    font-weight: 700;
    margin-right: 6px;
}
.bot-status-failed {
    color: #e55353;
    font-weight: 700;
    margin-right: 6px;
}
.iiko-status-pre {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 12px;
    font-size: 12px;
    max-height: 500px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-all;
}
</style>
